import {
  accountGet,
  accountPost,
  accountDelete,
  accountPut
} from './prefixedUrls.js';

import axios from './axios.setup.js';

/**
 * @typedef Addressbook
 * @property {number} id
 * @property {string} name
 * @property {string} description
 */

/**
 * @typedef Contact
 * @property {number} id
 * @property {string} name
 * @property {string} surname
 * @property {string} email
 * @property {string} company
 * @property {Addressbook[]} addressbooks
 */

/**
 * Get all the user address books
 * @param {string} accountId The account uuid
 * @returns {Promise<Addressbook[]>}
 */
export async function getAll(accountId) {
  let res = await accountGet('addressbooks', accountId);
  return res.data;
}

/**
 * Get an addressbook by its id
 * @param {string} accountId The account uuid
 * @param {string} id The addressbook id
 * @returns {Promise<Addressbook>}
 */
export async function get(accountId, id) {
  let res = await accountGet(`addressbooks/${id}`, accountId);
  return res.data;
}

/**
 * Get contacts of addressbook
 *
 * @param {string} accountId The account uuid
 * @param {number} addressbookId The addressbook id
 * @returns {Promise<Contact[]>}
 */
export async function getContacts(accountId, addressbookId) {
  let res = await accountGet(`addressbooks/${addressbookId}/contacts`, accountId);
  return res.data;
}

/**
 * Create an addressbook
 *
 * @param {string} accountId The account uuid
 * @param {Addressbook} addressbook
 * @returns {Promise<Contact[]>}
 */
export async function create(accountId, addressbook) {
  let res = await accountPost(`addressbooks`, accountId, addressbook);
  return res.data;
}

/**
 * Update an addressbook
 *
 * @param {string} accountId The account uuid
 * @param {Addressbook} addressbook
 * @returns {Promise<Contact[]>}
 */
export async function update(accountId, addressbook) {
  let res = await accountPut(`addressbooks/${addressbook.id}`, accountId, addressbook);
  return res.data;
}

/**
 * Delete an addressbook
 *
 * @param {string} accountId The account uuid
 * @param {number} addressbookId
 * @returns {Promise<Contact[]>}
 */
export async function remove(accountId, addressbookId) {
  let res = await accountDelete(`addressbooks/${addressbookId}`, accountId);
  return res.data;
}

/**
 * Attaches a contact to an addressbook
 *
 * @param {string} accountId The account uuid
 * @param {number} addressbookId The addressbook id
 * @param {string} contactId The contact id
 */
export async function attach(accountId, addressbookId, contactId) {
  let res = await accountPost(`addressbooks/${addressbookId}/contacts/${contactId}`, accountId, {});
  return res.data;
}

/**
 * Detaches a contact from an addressbook
 *
 * @param {string} accountId The account uuid
 * @param {number} addressbookId The addressbook id
 * @param {string} contactId The contact id
 */
export async function detach(accountId, addressbookId, contactId) {
  let res = await accountDelete(`addressbooks/${addressbookId}/contacts/${contactId}`, accountId, {})
  return res.data;
}
